export default "__VITE_ASSET__Cpu_cWzj__"